export default "__VITE_ASSET__DN8PoGdL__"